import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
//import SectionCockpit from './Cockpit/SectionCockpit';
import HealthCockpit from "./Cockpit/HealthCockpit";
import { useTheme } from "@mui/material";
import { useTranslation } from '../../language';


export default function CockpitWelcome() {

    const theme = useTheme();
    const { t, language } = useTranslation();
  

return (

    <PageProtectedLayout

      headline={t('page_hl_preventive_health')}
      specify={t('page_sp_summary')}
      headlineMb={{ xs: 2, sm: 3 }}
      >

    {/* Main Page Content  */} 
     <HealthCockpit />
    

    </PageProtectedLayout>

  );
}